import React from 'react';

export default function ApprovalDokumen() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Approval Dokumen</h1>
      <p className="text-gray-500">Halaman Approval Dokumen</p>
    </div>
  );
}
